// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nstrong[data-v-1a06aace] {\n  min-height: 30px;\n  display: inline-flex;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
